import React, { FC, useMemo } from 'react'
import { NavLink } from 'react-router-dom'
import styles from './Navbar.module.scss'
import { cn } from '../../shared/utils'
import { useAbility } from '@casl/react'
import { AbilityContext } from '../../shared/abilities'
import { AppAbility } from '../../shared/abilities/types'
import { useZoneManager } from '../../shared/hooks/useZoneManager'

type TNavbarProps = {}


const buildAllowedNavbarItems = (ability: AppAbility) => {
  const items: {
    key: string
    label: string
    url: string
    zoneRelated?: boolean
    isHidden?: boolean
  }[] = [
    {
      key: 'feed',
      label: 'Story Feed',
      url: 'feed',
      zoneRelated: true
    }, {
      key: 'projects',
      label: 'Projects',
      url: 'projects',
      zoneRelated: true
    }, {
      key: 'charts',
      label: 'Charts',
      url: 'charts',
      zoneRelated: true
    }, {
      key: 'products',
      label: 'Products',
      url: 'products',
      zoneRelated: true
    }, {
      key: 'admin',
      label: 'Admin',
      url: '/admin',
      isHidden: ability.cannot('access', 'AdminPanel')
    }
  ]
  return items
}

export const Navbar: FC<TNavbarProps> = (props) => {
  const ability = useAbility(AbilityContext)

  const { buildZoneUrl } = useZoneManager()

  const navbarItems = useMemo(() => {
    return buildAllowedNavbarItems(ability)
      .filter((item) => !item.isHidden)
      .map((item) => {
        if (item.zoneRelated) {
          return {
            ...item,
            url: buildZoneUrl(item.url)
          }
        }
        return item
      })
  }, [ability, buildZoneUrl])

  return (
    <nav className={cn(styles.container, 'navbar')}>
      <div className={styles.navMenu}>
        {navbarItems.map((item, index) => (
          <NavLink
            key={item.label}
            to={item.url}
          >
            {({ isActive }) => (
              <span className={cn(styles.navMenu__item, {
                [styles.active]: isActive
              })}>{item.label}</span>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
